export const text = {
  appName: 'HarvestMate',
  daysOfWeek: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ] as const,
  daysOfWeekMondayFirst: [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ] as const,
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ] as const,
  am: 'AM',
  pm: 'PM',

  loading: 'Loading...',
  appUpdatedToast: "You're on the latest version.",
  saving: 'Saving...',
  cancel: 'Cancel',
  confirm: 'Confirm',
  delete: 'Delete',
  email: 'Email',
  password: 'Password',
  emailPlaceholder: 'Enter your email',
  passwordPlaceholder: 'Enter your password',
  alertSuccess: 'Success',
  alertError: 'Error',
  orDivider: 'or',
  comingSoon: 'Coming soon.',
};
